/**
 * Các loại phiếu do trang xuất bán xử lý. Cả hai cùng gọi /api/v1/Outward/*-sale-order-out-ward
 * và cùng handler CreateSaleOutWardCommand ở backend.
 */
export const SALE_SOURCE_TYPES = ["XUAT_BAN", "XUAT_DOI_TRA"] as const;

export type SaleSourceType = (typeof SALE_SOURCE_TYPES)[number];

export const isSaleSourceType = (
  sourceType: string | null | undefined,
): sourceType is SaleSourceType =>
  !!sourceType && (SALE_SOURCE_TYPES as readonly string[]).includes(sourceType);

/** Khác biệt giữa xuất bán và xuất đổi trả. Thêm khác biệt mới ở đây thay vì rải `if` trong trang. */
export interface SaleKindConfig {
  label: string;
  /** Nhãn nút in phiếu sau khi khoá / ở trang chi tiết */
  printLabel: string;
  /** Tiêu đề khung danh sách dòng đơn */
  orderSectionTitle: string;
  /** true: còn lệch số lượng thì không cho hoàn thành. false: hỏi xác nhận rồi cho hoàn thành */
  lockRequiresNoVariance: boolean;
  /** Sau khi khoá: tạo đơn GHTK / Ahamove / Grab theo đơn vị vận chuyển của đơn. Bật thì gửi dispatchSaleOrder, backend consumer.delivery làm */
  createShippingOrders: boolean;
  /** Sau khi khoá: gửi ZNS báo khách. Bật thì gửi dispatchSaleOrder, backend consumer.delivery làm */
  sendZns: boolean;
  /** true: mở hộp chọn mẫu in (OptionPrintOutWard). false: in thẳng */
  printWithOptions: boolean;
  /** In biên bản bàn giao ở trang chi tiết */
  handoverPrint: boolean;
  /** In đơn TMĐT khi đơn có ecommerceOrderId */
  ecommercePrint: boolean;
  /** Menu "In những sản phẩm cần để đi nhặt sản phẩm" */
  pickingListPrint: boolean;
  /**
   * Cột "Serial nhập" trên lưới serial: chọn serial khách trả mà serial xuất này thay thế, backend ghi
   * TBL_SERIAL_EXCHANGE_LINK để bảo hành của serial mới tính từ lần bán đầu chuỗi. Chỉ xuất đổi trả
   */
  exchangeSerialColumn: boolean;
}

export const SALE_KIND_CONFIG: Record<SaleSourceType, SaleKindConfig> = {
  XUAT_BAN: {
    label: "Xuất bán",
    printLabel: "In phiếu xuất kho",
    orderSectionTitle: "Thông tin đơn hàng",
    lockRequiresNoVariance: true,
    createShippingOrders: true,
    sendZns: true,
    printWithOptions: true,
    handoverPrint: true,
    ecommercePrint: true,
    pickingListPrint: true,
    exchangeSerialColumn: false,
  },
  XUAT_DOI_TRA: {
    label: "Xuất đổi trả",
    printLabel: "In phiếu xuất đổi trả",
    orderSectionTitle: "Yêu cầu xuất kho",
    lockRequiresNoVariance: false,
    createShippingOrders: false,
    sendZns: false,
    printWithOptions: false,
    handoverPrint: false,
    ecommercePrint: false,
    pickingListPrint: false,
    exchangeSerialColumn: true,
  },
};

/** Giới hạn số serial một phiếu, giữ như trang cũ */
export const MAX_SERIALS_PER_OUTWARD = 5000;

/** Độ dài tối đa ghi chú phiếu, giữ như trang cũ */
export const MAX_DESCRIPTION_LENGTH = 300;
